import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth";

interface DefaultPasswordGuardProps {
  children: React.ReactNode;
}

/**
 * Guard component that redirects students with default passwords to the password change page
 * This should wrap all protected routes to ensure students can't access anything until they change their password
 */
export const DefaultPasswordGuard: React.FC<DefaultPasswordGuardProps> = ({ children }) => {
  const { user, profile, isDefaultPassword, loading } = useAuth();

  // Don't redirect if still loading
  if (loading) {
    return <div>Loading...</div>;
  }

  // Don't redirect if not authenticated
  if (!user || !profile) {
    return <>{children}</>;
  }

  // Only apply to students
  if (profile.role !== "student") {
    return <>{children}</>;
  }

  // Don't apply to test students - they don't need to change password
  if ((profile as any).is_test_student) {
    return <>{children}</>;
  }

  // Redirect to password change if student has default password
  if (isDefaultPassword) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
};
